// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupImage_wrapper__4Xd6K","wrapperBlurred":"PopupImage_wrapperBlurred__onf2C","mainImage":"PopupImage_mainImage__w3vox"};